import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import AdminPermissionData from "./permission-data";
import AdminPermissionForm from "./permission-form";

const AdminPermission = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_PERMISSION",
      "SUPERVISOR_PERMISSION"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ADMIN")}
        subTitle={i18n.get("VIEW_EDIT_ADMIN_PERMISSION")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />

      <AdminPermissionForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AdminPermissionData />
    </ET3PageDiv>
  );
});
export default AdminPermission;
